import axios from './request'

/**
 * @typedef Brand
 * @property {string} ID
 * @property {string} NAME
 * @property {boolean} SERIAL_REQUIRED
 * @property {string} SERIAL_MASK
 */

/**
 *
 * @param {import('axios').AxiosRequestConfig?} config
 * @returns {Promise<(Brand & {
 *   canVerifyWarranty: boolean,
 * })[]>}
 */
export default async function getBrands(config) {
	return Promise.all([
		axios.get('/api/Brand/getBrands/', config).then(({ data }) => data),
		axios.get('/api/SerialNumbers/getBrandsList/', config).then(({ data }) => data),
	]).then(([{ data: brands }, { data: brandsWarranty }]) => {
		const brandsMap = new Map()

		for (const index in brands) {
			const brand = brands[index]

			brandsMap.set(brand.ID, brand)
		}

		for (const brand of brandsWarranty) {
			const brandWarranty = brandsMap.get(brand.ID)

			if (!brandWarranty) continue;

			brandWarranty.canVerifyWarranty = true
		}

		return brands
	})
}
